export const firebaseConfig = {
  apiKey: 'AIzaSyBBG9yIGbg8QY-LDyevLCDnrNXiCSi66Co',
  authDomain: 'formulando.firebaseapp.com',
  databaseURL: 'https://formulando-default-rtdb.firebaseio.com',
  projectId: 'formulando',
  storageBucket: 'formulando.appspot.com',
  messagingSenderId: '27682882559',
  appId: '1:27682882559:web:75e7f956b3e3aaa566ddca',
  measurementId: 'G-465SC3FMGN',
};
